import { axiosInstance } from "../utils/axiosInstance";

export const loginService = async (body: any) => {
  const response = await axiosInstance.post("/auth/login", body).catch((e) => {
    throw e.response?.data.message;
  });
  // console.log("RESPONSE =>",response);

  const aldata = await response?.data.data;
  return aldata;

  // try {
  //   const response=await axiosInstance.post("/auth/login",body)
  //   return response.data.data;
  // } catch (error:any) {
  //   return error.response.data.message
  // }
};
